import type { MutationState } from "@tanstack/react-query";
import { useMutationState } from "@tanstack/react-query";

import { savedSearchMutationKeys } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/query";
import type { SavedSearchDto } from "app/pages/sales-intelligence/sub-modules/advanced-search/types/dto";

export const useUpdateSavedSearchMutationState = (): MutationState<SavedSearchDto> | undefined => {
    const updateSavedSearchMutationState = useMutationState<MutationState<SavedSearchDto>>({
        filters: { mutationKey: savedSearchMutationKeys.update() },
    });

    return updateSavedSearchMutationState[updateSavedSearchMutationState.length - 1];
};
